import { Controller } from '@hotwired/stimulus'
import Choices from 'choices.js'

// import 'choices.js/src/styles/choices'
// TODO style similar to https://github.com/Xibel/select2-tailwindcss/blob/master/src/css/styles.css
// import 'stylesheets/choices'

export default class extends Controller {
  static targets = ['input']

  declare readonly inputTarget: HTMLInputElement | HTMLSelectElement

  connect() {
    new Choices(this.inputTarget, {
      allowHTML: true,
    })
  }
}
